(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daynamic-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('os-product')) {
  class OSProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
    const run = () => { if (this._ready) return; this._ready = true; this.initGallery(); this.initReliableSticky(); this.initVariants(); this.initDelivery(); this.initFaq(); this.initVideos(); this.initBundleGuard(); this.initBuyAjax(); this.initCountdown(); this.initAddon(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
    }

    /* Reliable sticky gallery: does not rely on sticky-friendly theme ancestors. */
    initReliableSticky() {
      const gallery = this.querySelector('[data-os-gallery]');
      const grid = this.querySelector('.os__grid');
      if (!gallery || !grid) return;
      let scheduled = false;
      const update = () => {
        scheduled = false;
        if (window.matchMedia('(max-width: 989px)').matches) {
          gallery.style.transform = '';
          return;
        }
        // Read the grid, which does not move when the gallery is translated.
        const bounds = grid.getBoundingClientRect();
        const h = gallery.offsetHeight;
        const remaining = Math.max(0, grid.offsetHeight - h);
        const configuredTop = parseFloat(getComputedStyle(this).getPropertyValue('--os-top')) || 0;
        const offset = Math.min(remaining, Math.max(0, configuredTop - bounds.top));
        gallery.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      };
      const schedule = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(schedule);
        observer.observe(grid);
        observer.observe(gallery);
      }
      schedule();
    }

    /* ---------------- GALLERY ---------------- */
    initGallery() {
      const g = this.querySelector('[data-os-gallery]');
      if (!g) return;
      const main = g.querySelector('[data-os-main]');
      const track = g.querySelector('[data-os-track]');
      const slides = [...g.querySelectorAll('[data-os-slide]')];
      const thumbs = [...g.querySelectorAll('[data-os-thumb]')];
      const strip = g.querySelector('[data-os-strip]');
      const next = g.querySelector('[data-os-next]');
      const prev = g.querySelector('[data-os-prev]');
      let i = parseInt(g.dataset.start, 10) || 0;
      if (!slides.length) return;

      const keepThumbVisible = (t) => {
        if (!t || !strip) return;
        const a = t.getBoundingClientRect(), b = strip.getBoundingClientRect();
        if (a.left < b.left) strip.scrollBy({ left: a.left - b.left - 4, behavior: 'smooth' });
        else if (a.right > b.right) strip.scrollBy({ left: a.right - b.right + 4, behavior: 'smooth' });
      };

      const go = (n, instant) => {
        n = Math.max(0, Math.min(slides.length - 1, n));
        i = n;
        if (instant) track.style.transition = 'none';
        track.style.transform = 'translate3d(' + (-n * 100) + '%,0,0)';
        if (instant) { void track.offsetWidth; track.style.transition = ''; }
        thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === n); t.setAttribute('aria-current', k === n ? 'true' : 'false'); });
        slides.forEach((s, k) => {
          s.setAttribute('aria-hidden', k === n ? 'false' : 'true');
          if (k !== n) s.querySelectorAll('video').forEach(v => v.pause());
        });
        keepThumbVisible(thumbs[n]);
        if (prev) { prev.classList.toggle('is-visible', n > 0); prev.disabled = n === 0; }
        if (next) next.disabled = n === slides.length - 1;
      };
      go(i, true);

      thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
      if (next) next.addEventListener('click', () => go(i + 1));
      if (prev) prev.addEventListener('click', () => go(i - 1));
      main.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(i + 1);
        if (e.key === 'ArrowLeft') go(i - 1);
      });

      let sx = 0, sy = 0, dx = 0, active = false, dragging = false, moved = false;
      main.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('video,iframe,model-viewer,button,a')) return;
        active = true; dragging = false; moved = false; sx = e.clientX; sy = e.clientY; dx = 0;
      });
      main.addEventListener('pointermove', (e) => {
        if (!active) return;
        dx = e.clientX - sx;
        const dy = e.clientY - sy;
        if (!dragging) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            dragging = true; moved = true; track.style.transition = 'none';
            try { main.setPointerCapture(e.pointerId); } catch (_) {}
          } else return;
        }
        let off = dx;
        if ((i === 0 && dx > 0) || (i === slides.length - 1 && dx < 0)) off = dx * 0.35;
        track.style.transform = 'translate3d(calc(' + (-i * 100) + '% + ' + off + 'px),0,0)';
      });
      const end = () => {
        if (!active) return;
        active = false;
        if (dragging) {
          track.style.transition = '';
          const w = main.clientWidth;
          if (dx < -w * 0.15) go(i + 1);
          else if (dx > w * 0.15) go(i - 1);
          else go(i);
        }
        dragging = false;
      };
      main.addEventListener('pointerup', end);
      main.addEventListener('pointercancel', end);
      main.addEventListener('pointerleave', end);
      main.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      this._goToMedia = (id) => {
        const k = slides.findIndex(s => String(s.dataset.mediaId) === String(id));
        if (k > -1) go(k);
      };
    }

    /* ---------------- VARIANTS ---------------- */
    initVariants() {
      const dataEl = this.querySelector('[data-os-variants]');
      if (!dataEl) return;
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const selects = [...this.querySelectorAll('[data-os-option]')].sort((a, b) => a.dataset.osOption - b.dataset.osOption);
      const idInput = this.querySelector('form.os-form input[name="id"]');
      const buys = [...this.querySelectorAll('[data-os-buy]')];
      const prices = [...this.querySelectorAll('[data-os-price]')];
      const compares = [...this.querySelectorAll('[data-os-compare]')];
      const badges = [...this.querySelectorAll('[data-os-badge]')];

      const setBtn = (v) => buys.forEach(b => {
        const t = b.querySelector('[data-os-buy-text]');
        if (!v) { b.disabled = true; t.textContent = b.dataset.unavailable; }
        else if (!v.available) { b.disabled = true; t.textContent = b.dataset.soldout; }
        else { b.disabled = false; t.textContent = b.dataset.text; }
      });

      const update = () => {
        const vals = selects.map(s => s.value);
        const v = selects.length ? variants.find(x => x.options.every((o, k) => o === vals[k])) : variants[0];
        setBtn(v);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        prices.forEach(p => p.textContent = v.price);
        compares.forEach(c => { c.textContent = v.compare; c.hidden = !v.hasCompare; });
        badges.forEach(b => {
          const txt = (b.dataset.template || '').replace(/\{percent\}/g, v.percent).replace(/\{saved\}/g, v.saved).replace(/\{price\}/g, v.price);
          b.textContent = txt;
          b.hidden = !(v.hasCompare || b.dataset.always === 'true');
        });
        if (v.media && this._goToMedia) this._goToMedia(v.media);
        if (this.dataset.updateUrl === 'true' && window.history && history.replaceState) {
          try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (_) {}
        }
      };
      const cur = variants.find(x => String(x.id) === String(idInput && idInput.value)) || variants[0];
      if (cur) badges.forEach(b => {
        b.textContent = (b.dataset.template || '').replace(/\{percent\}/g, cur.percent).replace(/\{saved\}/g, cur.saved).replace(/\{price\}/g, cur.price);
      });
      selects.forEach(s => s.addEventListener('change', update));
    }

    /* ---------------- DELIVERY DATE ---------------- */
    initDelivery() {
      this.querySelectorAll('[data-os-delivery]').forEach(el => {
        const target = el.querySelector('[data-os-delivery-text]');
        const tpl = el.dataset.template || '';
        if (tpl.indexOf('{date}') === -1) { target.textContent = tpl; return; }
        const d = new Date();
        d.setDate(d.getDate() + (parseInt(el.dataset.days, 10) || 0));
        if (el.dataset.skip === 'true') { while (d.getDay() === 5 || d.getDay() === 6) d.setDate(d.getDate() + 1); }
        const opts = { weekday: 'long', day: 'numeric', month: 'long' };
        const loc = el.dataset.locale || 'ar-JO';
        let txt;
        try { txt = new Intl.DateTimeFormat(loc.indexOf('-u-') > -1 ? loc : loc + '-u-nu-latn', opts).format(d); }
        catch (_) { try { txt = new Intl.DateTimeFormat(undefined, opts).format(d); } catch (e) { txt = d.toDateString(); } }
        txt = txt.replace(/[،,]/g, '');
        const parts = tpl.split('{date}');
        target.textContent = '';
        target.appendChild(document.createTextNode(parts[0]));
        const st = document.createElement('strong'); st.textContent = txt; target.appendChild(st);
        target.appendChild(document.createTextNode(parts.slice(1).join('{date}')));
      });
    }

/* ---------------- KACHING BUNDLE GUARD ---------------- */
initBundleGuard() {
  const form = this.querySelector('form.os-form');
  if (!form) return;

  // Error message text: ekhane tomar moto change koro
  const MSG = 'من فضلك اختر الباقة أولاً قبل إتمام الطلب';

  const SELECTED = [
    '.kaching-bundles__bar--selected',
    '.kaching-bundles__bar input[type="radio"]:checked',
    '.kaching-bundles input[type="radio"]:checked',
    'kaching-bundles input[type="radio"]:checked'
  ].join(',');

  const hasBundle = () => !!document.querySelector(SELECTED);

  let timer;
  const getErr = () => form.querySelector('.os-bundle-err');

  const hideError = () => {
    const el = getErr();
    if (el) el.hidden = true;
    clearTimeout(timer);
  };

  const showError = () => {
    const btn = form.querySelector('[data-os-buy]');
    if (!btn) return;
    let el = getErr();
    if (!el) {
      el = document.createElement('div');
      el.className = 'os-bundle-err';
      el.setAttribute('role', 'alert');
      btn.parentElement.insertBefore(el, btn);
    }
    el.textContent = MSG;
    el.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(hideError, 5000);
  };

  const block = (e) => {
    if (hasBundle()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError();
  };

  // capture phase on window: runs before Kaching / theme handlers
  window.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-os-buy]') && form.contains(e.target)) block(e);
  }, true);
  window.addEventListener('submit', (e) => {
    if (e.target === form) block(e);
  }, true);

  // bundle select korle error message auto hide hobe
  document.addEventListener('click', () => {
    setTimeout(() => { if (hasBundle()) hideError(); }, 60);
  });
  document.addEventListener('change', () => {
    setTimeout(() => { if (hasBundle()) hideError(); }, 60);
  });
}

      /* ---------------- BUY → AJAX ADD + OPEN CART DRAWER (Minimog) ---------------- */
    initBuyAjax() {
      const form = this.querySelector('form.os-form');
      const btn = form && form.querySelector('[data-os-buy]');
      if (!form || !btn || btn.dataset.action !== 'drawer') return;

      const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      let busy = false;

      // capture phase: Kaching / theme-er submit handler-er age cholbe
      window.addEventListener('submit', (e) => {
        if (e.target !== form) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (busy || btn.disabled) return;
        busy = true;
        btn.disabled = true;

        const variantId = form.querySelector('[name="id"]').value;
        const quantity = form.querySelector('[name="quantity"]')?.value || 1;

        const drawerEl = document.querySelector('m-cart-drawer, cart-drawer');
        const drawerSection = drawerEl ? drawerEl.closest('.shopify-section') : null;
        const drawerSectionId = drawerSection ? drawerSection.id.replace('shopify-section-', '') : 'cart-drawer';

        const payload = {
          id: variantId,
          quantity: parseInt(quantity, 10),
          sections: [drawerSectionId, 'cart-icon-bubble', 'cart-drawer'].filter((v, i, a) => a.indexOf(v) === i)
        };

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((err) => { throw new Error(err.description || 'Could not add to cart'); });
            }
            return response.json();
          })
          .then((response) => {
            const pubsub = (window.MinimogTheme && window.MinimogTheme.pubsub) || (window.FoxTheme && window.FoxTheme.pubsub);

            if (pubsub) {
              pubsub.publish('cart:update', { cart: response, openDrawer: true, sections: response.sections });
              pubsub.publish('cart-drawer:refresh', { sections: response.sections });
              pubsub.publish('cart-icon-bubble:update', response.sections);
            }

            if (drawerEl && typeof drawerEl.renderContents === 'function') {
              drawerEl.renderContents(response);
            }

            if (drawerEl) {
              if (typeof drawerEl.open === 'function') drawerEl.open();
              else if (typeof drawerEl.show === 'function') drawerEl.show();
              else {
                drawerEl.setAttribute('open', '');
                drawerEl.classList.add('is-open', 'active');
              }
            } else {
              const icon = document.getElementById('m-cart-icon-bubble');
              if (icon) icon.click();
            }

            document.dispatchEvent(new CustomEvent('m:cart:add-success', { detail: { data: response } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch((error) => {
            console.error('Minimog Native Cart Error:', error);
            alert(error.message || 'Error adding product to cart.');
          })
          .finally(() => {
            busy = false;
            btn.disabled = false;
          });
      }, true);
    }
    /* ---------------- COUNTDOWN (till midnight, auto-restart) ---------------- */
    initCountdown() {
      const els = [...this.querySelectorAll('[data-os-countdown]')];
      if (!els.length) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0); // next local midnight
        const diff = Math.max(0, Math.floor((end - now) / 1000));
        const h = pad(Math.floor(diff / 3600)), m = pad(Math.floor((diff % 3600) / 60)), s = pad(diff % 60);
        els.forEach((el) => {
          el.querySelector('[data-cd-h]').textContent = h;
          el.querySelector('[data-cd-m]').textContent = m;
          el.querySelector('[data-cd-s]').textContent = s;
        });
      };
      tick();
      setInterval(tick, 1000);
      document.addEventListener('visibilitychange', tick);
    }

        /* ---------------- ADD-ON (one-click add / remove, separate cart line) ---------------- */
    initAddon() {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.querySelectorAll('[data-os-addon]').forEach((card) => {
        const btn = card.querySelector('[data-os-addon-btn]');
        if (!btn || btn.disabled) return;
        const label = btn.querySelector('span');
        const vid = parseInt(card.dataset.variant, 10);
        let busy = false;

        const render = (added) => {
          card.classList.toggle('is-added', added);
          btn.setAttribute('aria-pressed', added ? 'true' : 'false');
          label.textContent = added ? btn.dataset.added : btn.dataset.add;
        };

        const getCart = () =>
          fetch(root + 'cart.js?_=' + Date.now(), {
            headers: { 'Accept': 'application/json' },
            cache: 'no-store'
          }).then((r) => r.json());

        const post = (url, body) =>
          fetch(root + url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });

        const findLines = (cart) => cart.items.filter((i) => i.variant_id === vid);

        const sync = () =>
          getCart().then((c) => render(findLines(c).length > 0)).catch(() => {});

        // initial state + keep in sync when user comes back to the tab / bfcache
        sync();
        window.addEventListener('pageshow', sync);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });

        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          if (busy) return;
          busy = true; btn.disabled = true;
          try {
            // always decide from the REAL cart state, not a local flag
            const cart = await getCart();
            const lines = findLines(cart);

            if (lines.length) {
              // REMOVE: delete every line of this add-on completely
              let last;
              for (const line of lines) {
                const r = await post('cart/change.js', { id: line.key, quantity: 0 });
                if (!r.ok) throw new Error('remove failed');
                last = await r.json();
              }
              render(false);
            } else {
              // ADD: exactly 1 unit
              const r = await post('cart/add.js', { items: [{ id: vid, quantity: 1 }] });
              if (!r.ok) throw new Error('add failed');
              render(true);
            }

            // let theme / cart drawer know the cart changed
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          } catch (_) {
            sync(); // on any error, re-sync button with the real cart
          } finally {
            busy = false; btn.disabled = false;
          }
        });
      });
    }

    /* ---------------- FAQ ---------------- */
    initFaq() {
      this.addEventListener('click', (e) => {
        const q = e.target.closest('[data-os-faq-q]');
        if (!q) return;
        const item = q.closest('.os-faq');
        const open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---------------- VIDEO CAROUSEL ---------------- */
    initVideos() {
      this.querySelectorAll('[data-os-vc]').forEach(vc => {
        const sc = vc.querySelector('[data-os-scroller]');
        if (!sc) return;
        const bar = vc.querySelector('[data-os-bar]');
        const th = vc.querySelector('[data-os-bar-thumb]');

        const upd = () => {
          if (!bar || !th) return;
          const max = sc.scrollWidth - sc.clientWidth;
          if (max <= 1) { bar.hidden = true; return; }
          bar.hidden = false;
          const pct = sc.clientWidth / sc.scrollWidth * 100;
          const p = Math.min(1, Math.abs(sc.scrollLeft) / max);
          th.style.width = pct + '%';
          th.style.marginInlineStart = (p * (100 - pct)) + '%';
        };
        sc.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        if (window.ResizeObserver) new ResizeObserver(upd).observe(sc);
        upd();

        let down = false, moved = false, sx = 0, sl = 0;
        sc.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = sc.scrollLeft; });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - sx;
          if (Math.abs(dx) > 5) { moved = true; sc.classList.add('is-drag'); }
          if (moved) sc.scrollLeft = sl - dx;
        });
        window.addEventListener('pointerup', () => { if (!down) return; down = false; sc.classList.remove('is-drag'); });
        sc.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

        const stopAll = () => vc.querySelectorAll('.os-vc__card.is-playing').forEach(c => {
          const m = c.querySelector('.os-vc__media'); if (m) m.remove(); c.classList.remove('is-playing');
        });
        vc.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-os-play]');
          if (!btn) return;
          const card = btn.closest('[data-os-card]');
          stopAll();
          let el;
          if (card.dataset.kind === 'hosted') {
            el = document.createElement('video');
            el.src = card.dataset.src; el.controls = true; el.autoplay = true; el.playsInline = true;
          } else {
            el = document.createElement('iframe');
            el.src = card.dataset.src;
            el.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
            el.setAttribute('allowfullscreen', '');
          }
          el.className = 'os-vc__media';
          card.appendChild(el);
          card.classList.add('is-playing');
          if (el.play) el.play().catch(() => {});
        });
      });
    }
  }
  customElements.define('os-product', OSProduct);
}

  } catch(e) { console.error(e); }
})();
})();
